import { useLocale } from '@dreamstack/i18n'
import { trpc } from '@dreamstack/trpc/client'
import type { FunctionComponent } from 'react'
import { SuperRichText } from '../blocks/SuperRichText'

export const CitiesFooter: FunctionComponent<
  React.PropsWithChildren<{}>
> = () => {
  const locale = useLocale()
  const { data: footer } = trpc.cms.getFooter.useQuery(
    { locale },
    {
      trpc: { ssr: true },
      staleTime: Infinity,
    }
  )

  if (!footer) {
    return null
  }

  return (
    <div>
      <div className="flex flex-col flex-wrap min-w-0">
        <SuperRichText richText={footer.text} blackBackground />
      </div>
    </div>
  )
}
